import {isHttpErrorResponse} from './isHttpErrorResponse';

export function getHttpError<T>(
  error: unknown,
  guardFn: (val: any) => val is T,
): T | null {
  return _getHttpErrorDefault<T, null>(error, guardFn, null);
}

export function getHttpErrorDefault<T>(
  error: unknown,
  guardFn: (val: any) => val is T,
  defaultVal: T,
): T {
  return _getHttpErrorDefault<T, T>(error, guardFn, defaultVal);
}

function _getHttpErrorDefault<T, TDefault>(
  error: unknown,
  guardFn: (val: any) => val is T,
  defaultVal: TDefault,
): T | TDefault {
  if (isHttpErrorResponse(error) && guardFn(error.error)) {
    return error.error;
  }
  return defaultVal;
}

// maybe this is useful at some point, but normally, you want better typing
// export function getAnyHttpError(error: unknown): any | null {
//   if (isHttpErrorResponse(error)) {
//     return error.error;
//   }
//   return null;
// }
